export class FiltroManifestoPorUsuarioDTO {

  dataInicial: string;
  dataFinal: string;
  nomeManifestante: string;
  tipoPessoa: string;
  page: number;
  municipio: string;
  representanteUsuario: string;

  constructor() {

    this.dataInicial = 'null';
    this.dataFinal = 'null';
    this.nomeManifestante = null;
    this.tipoPessoa = 'FISICA';
    this.page = 0;
    this.municipio = null;
    this.representanteUsuario = null;

  }

}
